import { DropDownList } from "@progress/kendo-react-dropdowns";
import { cloneElement } from "react";
import { useTranslation } from "react-i18next";

function RelationCardinalityDropdown({
    value,
    onChange
}) {

    const { t } = useTranslation("linked_entity/recommended_relation_card", { useSuspense: false })

    const cardinalityTextMap = {
        "1-1": "One to One",
        "1-*": "One to Many",
        "*-*": "Many to Many",
    }

    const data = Object.keys(cardinalityTextMap).map(key => ({
        text: t("cardinality." + key, { ns: "linked_entity/recommended_relation_card" }),
        value: key
    }));
    const currentValue = {
        text: t("cardinality." + value, { ns: "linked_entity/recommended_relation_card" }),
        value
    }

    function handleChange(event) {
        event.nativeEvent.stopPropagation();
        onChange(event);
    }

    function itemRender(li, itemProps) {
        if (itemProps.dataItem.value === currentValue.value) {
            return cloneElement(li, {
                ...li.props,
                className: li.props.className + " k-state-selected"
            });
        }
        return cloneElement(li, li.props);
    };

    return (
        <DropDownList
            className="border-0"
            textField="text"
            data={data}
            value={currentValue}
            onChange={handleChange}
            onOpen={e => {
                e.syntheticEvent.stopPropagation();
            }}
            onClose={e => {
                e.syntheticEvent.stopPropagation();
            }}
            itemRender={itemRender}
        />
    )
}

const valueRender = (element, value) => {
    if (!value) {
        return element;
    }
    const children = [
        <span className="bigger txt-link pointer">&nbsp; {element.props.children}</span>,
    ];
    return cloneElement(
        element,
        {
            ...element.props,
            className: element.props.className + " w-100 d-inline-block"
        },
        children
    );
};

const itemRender = (li, itemProps) => {
    const itemChildren = (
        <span
            className="bigger txt-link pointer w-100"
        >
            {li.props.children}
        </span>
    );
    return cloneElement(li, li.props, itemChildren);
  };

export default RelationCardinalityDropdown;